import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import AllCourseList from '../components/AllCourseList';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import KelasPopuler from '../components/LandingComponent/KelasPopuler';
import Route from '../components/LandingComponent/Route';
import LandingBannerNew from '../components/LandingNew/LandingBannerNew';
import LoadingSpinner from '../Layout/LoadingSpinner';
import { removeScript } from '../Utils/Utils';

class CourseDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  fetchCourseList = async () => {
    this.props.dispatch({ type: 'TOGGLE_LOADING_TRUE' });
    const access_token = localStorage.getItem('access_token');
    axios
      .get(`${window.$API_URL}api/course`, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${access_token}` },
      })
      .then((success) => {
        this.props.dispatch({ type: 'TOGGLE_LOADING_FALSE' });
        this.props.dispatch({
          type: 'UPDATE_ALL_COURSE_LIST',
          payload: success.data.data,
        });
        this.props.dispatch({
          type: 'UPDATE_COURSE_RESULT',
          payload: {
            result_from: success.data.from,
            result_to: success.data.to,
          },
        });
      })
      .catch((error) => {
        this.props.dispatch({ type: 'TOGGLE_LOADING_FALSE' });
      });
  };

  componentDidMount = async () => {
    // this.fetchCourseList()
  };

  componentWillUnmount() {
    removeScript('https://app.sandbox.midtrans.com/snap/snap.js');
  }

  render() {
    return (
      <>
        <Header />
        <div className="container container-homepage d-flex flex-column">
          <Route name="Semua Kelas" />
          <LandingBannerNew />
          <KelasPopuler landing={false} />
          <AllCourseList />
        </div>
        <Footer />
        {this.props.isLoading ? <LoadingSpinner text={'Mohon menunggu..'} /> : ''}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { isLoading: state.isLoading };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseDetail);
